import * as React from 'react';
import Container from "@mui/material/Container/Container";
import Typography from "@mui/material/Typography/Typography";
import Stack from "@mui/material/Stack/Stack";
import Box from "@mui/material/Box/Box";
import Grid from "@mui/material/Grid/Grid";
import { styled } from '@mui/material/styles';
import firebase from "../firebase/firebase";
import {useContext} from "react";
import {AuthUserContext} from "../providers/AuthProvider";
import moment from "moment";


export default function ActivitiesComponent() {
  const {  profile} = useContext(AuthUserContext);

  const Input = styled('input')({
    display: 'none',
  })
  const [notifications, setNotifications] = React.useState([])
  React.useEffect(() => {

    const notificationsRef = firebase.firestore().collection('activities').orderBy('createdAt', 'desc');
    notificationsRef
      .where('uid', '==', profile?.uid)
      .limit(10)
      .get()
      .then((data) => {
        if (data?.size > 0) {
          const list = []
          data.docs.forEach((d) => {
            list.push({id: d.id, ...d.data()})
          })
          setNotifications(list);
        }
      })

  }, [])

  return (

    <Container maxWidth="md" component="main" sx={{textAlign:'left', mt:5, pb:5,}}>
        <Typography variant={'h5'} color={'primary'} sx={{borderBottom: '1px solid #204488'}}>
          RECENT ACTIVITIES
            </Typography>
          
      <Grid  container
             direction="row"
             alignItems="center"
      >
        <Grid
          xs={12}
        >
          <Stack direction="column"
                 spacing={3}
          >
            <span/>
            {notifications && notifications.length > 0 && notifications.map((activity) => (
              <Box sx={{ borderBottom:'1px solid #204488', p:1, pb: 3}}>
                <Stack  direction="row"
                        alignItems="center"                 spacing={2}
                >
                  <Typography  sx={{flex:1}}>
                    {activity.text}
                  </Typography>
                  <Typography  variant='caption'>
                    {moment(activity.createdAt.seconds * 1000).format('hh:mm:a')}
                  </Typography>
                </Stack>

              </Box>
            ))}



          </Stack>
        </Grid>
      </Grid>
    </Container>
  );


}